<template>
  <div class="moow-master-container">
    <b-container class="dashboard-container">
      <b-row>
        <b-col xl="1" lg="1" md="0" />
        <b-col xl="10" lg="10" md="12" class="m-0 p-0">
          <div @click="reloadDashboardItems" class="help-action-btn reload-items">
            <md-button class="md-icon-button md-raised" :disabled="loadingStays">
              <div v-if="loadingStays" class="loader-rolling-local_white" style="color:white"></div>
              <md-icon v-else>cached</md-icon>
            </md-button>
          </div>
          <div @click="showHelpDialog('bookingStatus')" class="help-action-btn help-dialog">
            <md-button class="md-fab md-dense play-cta-fab_flat">
              <md-icon>help_outline</md-icon>
            </md-button>
          </div>

          <md-tabs
            md-sync-route
            :md-active-tab="activeTab"
            id="mo-accent"
            style="width: 100%;max-width:100vw;"
            @md-changed="changedTab"
            class="md-primary play-tabs dark"
            md-elevation="5"
          >
            <md-tab id="tab-active" md-label="Stays" class="mo-listings-tab">
              <stay-previews ref="stayPreviewsRef" />
            </md-tab>
          </md-tabs>
        </b-col>
        <b-col xl="1" lg="1" md="0" />
      </b-row>
    </b-container>
  </div>
</template>
<script>
import StayPreviews from "../../components/dashboard/stayPreviews.vue";
import DashboardDrawer from "../../components/dashboard/dashDrawer.vue";
export default {
  components: {
    "stay-previews": StayPreviews
  },
  data() {
    return {
      reloadingDasboardItems: false,
      activeTab: ""
    };
  },
  computed: {
    loadingStays() {
      return this.$store.getters.loadingStays;
    },
    placeholder() {
      return require("../../assets/placeholder.png");
    },
    refreshIcon() {
      return require("../../assets/refresh.svg");
    },
    loaderRolling() {
      return required("../../assets/loader-rolling.svg");
    }
  },
  created() {
    this.$emit("emitChangeViewTitle", "Your Stays");
    // As this view is only seeable to te tenant role, auto change is done.
    this.$store.dispatch("editUserViewRole", "tenant");
  },
  updated() {},
  methods: {
    showHelpDialog(whatAbout) {
      var title = "";
      var message = "";
      if (whatAbout == "bookingStatus") {
        title = "Stays view is for tenants";
        message =
          "Here you can find all the inquiries you have made to the landlord. Each inquiry has a status. Confirmed means you can move in. Pending means that it is either waiting on the landlord to confirm or for the booking fee to be paid";
      }
      this.$emit("emitToggleHelpDialog", { title, message });
    },
    changedTab(tabId) {
      this.activeTab = tabId;
    },
    updateReloadingDasboardItems(status) {
      this.reloadingDasboardItems = status;
    },
    reloadDashboardItems() {
      if (this.$refs.stayPreviewsRef) this.$refs.stayPreviewsRef.reload();
    },
    notifyError(title, msg) {
      this.$notify({
        title: title,
        message: msg
      });
    },
    viewBooking(bookingId) {
      if (!bookingId)
        this.notifyError(
          "Something is not right",
          "cannot redirect to booking automatically"
        );
      this.$router.push({
        name: "booking",
        params: {
          dealId: bookingId,
          ownerViewingForced: false,
          redirect: "stays"
        }
      });
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/dashboard.css";
@import "../../assets/styles/global.css";
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Stays.vue